import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BasicResponse } from 'src/app/core/models/response/response';
import { AMLRiskSummary, AMLComment } from 'src/app/views/employee/employee';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AmlRiskSummaryService {
  private http = inject(HttpClient);

  private customerServicePath = `${environment.apiPrefix}${environment.customerServiceExt}/`;
  // EE (Employee) Comment APIs base
  // private eeCommentBaseUrl = 'http://localhost:8093/api/v1/int/ee/aml_comment';
  private eeCommentBaseUrl = this.customerServicePath + 'ee/aml_comment';

  // ER (Employer) Comment APIs base
  //private erCommentBaseUrl = 'http://localhost:8093/api/v1/int/er/aml_comment';
  private erCommentBaseUrl = this.customerServicePath + 'er/aml_comment';

  /**
   * 获取AML Risk Summary (包含latestComment)
   * EE: GET /api/v1/int/ee/aml_comment/aml_risk_summary/{customerId}
   * ER: GET /api/v1/int/er/aml_comment/aml_risk_summary/{customerId}
   */
  getAMLRiskSummary(customerId: string, entityType: 'EE' | 'ER' = 'EE'): Observable<BasicResponse<AMLRiskSummary>> {
    const baseUrl = entityType === 'EE' ? this.eeCommentBaseUrl : this.erCommentBaseUrl;
    const url = `${baseUrl}/aml_risk_summary/${customerId}`;

    return this.http.get<BasicResponse<AMLRiskSummary>>(url);
  }

  /**
   * 获取最新评论
   * EE: GET /api/v1/int/ee/aml_comment/latest/{customerId}
   * ER: GET /api/v1/int/er/aml_comment/latest/{customerId}
   */
  getLatestComment(customerId: string, entityType: 'EE' | 'ER'): Observable<BasicResponse<AMLComment>> {
    const baseUrl = entityType === 'EE' ? this.eeCommentBaseUrl : this.erCommentBaseUrl;
    const url = `${baseUrl}/latest/${customerId}`;

    return this.http.get<BasicResponse<AMLComment>>(url);
  }

  /**
   * 提交评论(创建或更新)
   * EE: POST /api/v1/int/ee/aml_comment/submit
   * ER: POST /api/v1/int/er/aml_comment/submit
   */
  submitComment(
    request: {
      customerId: string;
      comment: string;
      version?: number;
    },
    entityType: 'EE' | 'ER'
  ): Observable<BasicResponse<AMLComment>> {
    const baseUrl = entityType === 'EE' ? this.eeCommentBaseUrl : this.erCommentBaseUrl;
    const url = `${baseUrl}/submit`;

    return this.http.post<BasicResponse<AMLComment>>(url, request);
  }

  /**
   * 获取评论历史
   * EE: GET /api/v1/int/ee/aml_comment/by-customer/{customerId}
   * ER: GET /api/v1/int/er/aml_comment/by-customer/{customerId}
   */
  getCommentHistory(customerId: string, entityType: 'EE' | 'ER'): Observable<BasicResponse<AMLComment[]>> {
    const baseUrl = entityType === 'EE' ? this.eeCommentBaseUrl : this.erCommentBaseUrl;
    const url = `${baseUrl}/by-customer/${customerId}`;

    return this.http.get<BasicResponse<AMLComment[]>>(url);
  }
}
